/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateStudentResponse } from './CreateStudentResponse';
import {
    CreateStudentResponseFromJSON,
    CreateStudentResponseFromJSONTyped,
    CreateStudentResponseToJSON,
    CreateStudentResponseToJSONTyped,
} from './CreateStudentResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateStudentResponse
 */
export interface ResultOfCreateStudentResponse {
    /**
     * 
     * @type {CreateStudentResponse}
     * @memberof ResultOfCreateStudentResponse
     */
    data: CreateStudentResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateStudentResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateStudentResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateStudentResponse interface.
 */
export function instanceOfResultOfCreateStudentResponse(value: object): value is ResultOfCreateStudentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateStudentResponseFromJSON(json: any): ResultOfCreateStudentResponse {
    return ResultOfCreateStudentResponseFromJSONTyped(json, false);
}

export function ResultOfCreateStudentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateStudentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateStudentResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateStudentResponseToJSON(json: any): ResultOfCreateStudentResponse {
    return ResultOfCreateStudentResponseToJSONTyped(json, false);
}

export function ResultOfCreateStudentResponseToJSONTyped(value?: ResultOfCreateStudentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateStudentResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

